import { Nullable } from "web/types/Utils";

const getDateTime = (
  date?: Nullable<string | number | Date>,
  withTime = false
) => {
  try {
    if (typeof date === "string" || typeof date === "number") {
      return withTime
        ? new Date(date).toISOString()
        : new Date(date).toISOString().slice(0, 10);
    }
    if (date instanceof Date) {
      return withTime ? date.toISOString() : date.toISOString().slice(0, 10);
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
};

export default getDateTime;
